const initState = {
    fatherCropImg: '',
    motherCropImg: '',
    fatherOriginImg: '',
    motherOriginImg: '',
    currentCropType: 'father',
    girlResultUrl: '',
    girlResultImageUrl: '',
    isAutoDetectFace: false,
};
export const SET_MOTHER_CROP = 'SET_MOTHER_CROP';
export const SET_FATHER_CROP = 'SET_FATHER_CROP';
export const SET_MOTHER_ORIGIN = 'SET_MOTHER_ORIGIN';
export const SET_FATHER_ORIGIN = 'SET_FATHER_ORIGIN';
export const SET_CROP_TYPE = 'SET_CROP_TYPE';
export const SET_GIRL_RESULT_URL = 'SET_GIRL_RESULT_URL';
export const SET_GIRL_RESULT_IMAGE_URL = 'SET_GIRL_RESULT_IMAGE_URL';
export const SET_AUTO_DETECT_FACE = 'SET_AUTO_DETECT_FACE';
export const setFatherCropImg = (img) => ({
    type: SET_FATHER_CROP,
    payload: img,
});
export const setMotherCropImg = (img) => ({
    type: SET_MOTHER_CROP,
    payload: img,
});
export const setFatherOriginImg = (img) => ({
    type: SET_FATHER_ORIGIN,
    payload: img,
});
export const setMotherOriginImg = (img) => ({
    type: SET_MOTHER_ORIGIN,
    payload: img,
});
export const setCropType = (type) => ({
    type: SET_CROP_TYPE,
    payload: type
});
export const setGirlResultUrl = (url) => ({
    type: SET_GIRL_RESULT_URL,
    payload: url,
});
export const setGirlResultImageUrl = (url) => ({
    type: SET_GIRL_RESULT_IMAGE_URL,
    payload: url,
});
export const setAutoDetectFace = (status) => ({
    type: SET_AUTO_DETECT_FACE,
    payload: status,
});
const h5BabyReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_MOTHER_CROP:
            return Object.assign(Object.assign({}, state), { motherCropImg: action.payload });
        case SET_FATHER_CROP:
            return Object.assign(Object.assign({}, state), { fatherCropImg: action.payload });
        case SET_MOTHER_ORIGIN:
            return Object.assign(Object.assign({}, state), { motherOriginImg: action.payload });
        case SET_FATHER_ORIGIN:
            return Object.assign(Object.assign({}, state), { fatherOriginImg: action.payload });
        case SET_CROP_TYPE:
            return Object.assign(Object.assign({}, state), { currentCropType: action.payload });
        case SET_GIRL_RESULT_URL:
            return Object.assign(Object.assign({}, state), { girlResultUrl: action.payload });
        case SET_GIRL_RESULT_IMAGE_URL:
            return Object.assign(Object.assign({}, state), { girlResultImageUrl: action.payload });
        case SET_AUTO_DETECT_FACE:
            return Object.assign(Object.assign({}, state), { isAutoDetectFace: action.payload });
        default:
            return state;
    }
};
export default h5BabyReducer;
